// app.js -- boots the RatPortal widget